<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'qcReviews'">
  <p-tabMenu [model]="tabMenuItems" [scrollable]="true" [activeItem]="activeItem" [style]="{}"></p-tabMenu>

  <div style="margin-top: 1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <h2 class="title-main">{{ 'QCPage.TitleSectionReviewed' | translate }}</h2>
        </div>
      </div>
      <div class="body-card">
        <!--
          <p class="subtitle">{{ 'QCPage.SubtitleSectionReviewed' | translate }}</p>
        -->

        <div class="forwarder-reviews-dataview">
          <p-dataView #dv
            [value]="reviews2"
            [rows]="10"
            [paginator]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [loading]="loading"
            emptyMessage="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.EmptyResultsText' | translate}}"
            >
            <ng-template let-review pTemplate="listItem">
              <div class="card" [style]="{'margin-bottom': '20px'}">
                <div class="container-card">

                  <div class="container-row">

                    <div class="row-style">
                      <div class="container-flex-fit">

                        <div class="container-img">
                          <img [src]="getIconUrl(review.varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; min-width: 50px; height: auto;" alt="" *ngIf="review.varietyUrlIcon"/>
                          <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!review.varietyUrlIcon">
                            no_photography
                          </span>
                        </div>
                        <div class="flex-container container-main-info">
                          <h2 class="text-main"  style="font-size: 14px;">{{review | speciesName}} / {{review.varietyName}}</h2>
                          <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.CodeText' | translate}}:</strong> {{review.importOrderSequence}}</span>
                          <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.InstructiveText' | translate}}:</strong> {{review.delivery.deliveryInstructions}}</span>
                          <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.ContainerText' | translate}}:</strong> {{review.delivery.containerNumber}}</span>
                        </div>
                      </div>
                    </div>
                    <!--
                    -->

                    <div class="border-lat"></div>

                    <div class="container-countries flex flex-row">
                      <div class="country-container w-4">
                        <h4 class="title-small">{{ 'ForwarderPage.ForwarderReviewsPending.OriginPort' | translate }}</h4>
                          <div class="flex justify-content-start align-items-center">
                            <img *ngIf="review.delivery.departurePort" [flag]="review.delivery.departurePort.country?.code" height="40px" alt=""/>
                            <div *ngIf="!review.delivery.departurePort" class="not-country"></div>
                            <div class="flex flex-column" style="margin-left: 10px;">
                              <span *ngIf="review.delivery.departurePort && translate.currentLang === 'en'" style="font-weight: bolder; font-size: small;">{{review.delivery.departurePort.country?.name}}</span>
                              <span *ngIf="review.delivery.departurePort  && translate.currentLang === 'es'" style="font-weight: bolder; font-size: small;">{{review.delivery.departurePort.country?.nameEs}}</span>
                              <span *ngIf="review.delivery.departurePort" style="font-size: small; ">{{review.delivery.departurePort.name}}</span>
                              <span *ngIf="!review.delivery.departurePort" style="font-size: small; ">{{review.departurePort}}</span>
                            </div>
                          </div>
                      </div>

                      <div class="container-flex-fit pd-top-arrow flex-column w-4">
                        <div>
                          <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="review.delivery.transportType == 0" >directions_boat</span>
                          <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="review.delivery.transportType == 1" > flight</span>
                          <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
                        </div>
                        <div *ngIf="review.delivery?.ship" class="flex justify-content-center">
                          <span class="text-center" style="font-size: small;">{{ review.delivery?.ship }}</span>
                        </div>
                      </div>

                      <div class="country-container justify-content-start align-content-start align-items-start w-4">
                        <h4 class="title-small">{{ 'ForwarderPage.ForwarderReviewsPending.DestinationPort' | translate }}</h4>
                          <div class="flex justify-content-start align-items-start">
                            <img *ngIf="review.delivery.destinationPort" [flag]="review.delivery.destinationPort.country?.code" height="40px" alt=""/>
                            <div *ngIf="!review.delivery.destinationPort.country" class="not-country"></div>
                            <div class="flex flex-column" style="margin-left: 10px;">
                              <span *ngIf="review.delivery.destinationPort.country && translate.currentLang === 'en'" style="font-weight: bolder; font-size: small; ">{{review.delivery.destinationPort.country?.name}}</span>
                              <span *ngIf="review.delivery.destinationPort.country && translate.currentLang === 'es'" style="font-weight: bolder; font-size: small; ">{{review.delivery.destinationPort.country?.nameEs}}</span>
                              <span *ngIf="review.delivery.departurePort" style="font-size: small; ">{{review.delivery.destinationPort.name}}</span>
                              <span *ngIf="!review.delivery.departurePort" style="font-size: small; ">{{review.destinationPort}}</span>
                            </div>
                          </div>
                      </div>

                    </div>


                    <div class="border-lat"></div>

                    <div class="container-flex">
                      <button pButtom class="btn-main" (click)="goToReviewDocuments(review)">{{ 'ForwarderPage.ForwarderReviewsPending.ButtonReview' | translate }}</button>
                      <div class="flex justify-content-center align-items-center">
                        <p-tag icon="pi pi-exclamation-triangle" severity="warning" value="{{ 'QCPage.PartialPalletsApproved' | translate }}" [rounded]="false" *ngIf="review.importOrderDetailStatus == 3" [style]="{'padding':'.7em 1.5em','font-weight':'normal','width':'230px'}"></p-tag>
                        <p-tag icon="pi pi-check" severity="success" value="{{ 'QCPage.PalletsApproved' | translate }}" [rounded]="false" *ngIf="review.importOrderDetailStatus == 4" [style]="{'padding':'.7em 1.5em','font-weight':'normal','width':'230px'}"></p-tag>
                      </div>

                      <div class="btn-expand-custom">
                        <p-button
                          [icon]="review.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                          styleClass="p-button-rounded p-button-outlined "
                          (click)="setVisibleOrderDetail(review)"
                          >
                        </p-button>
                      </div>
                    </div>


                  </div>

                  <div class="container-row">
                    <div *ngIf="review.expanded" class="container-expanded">
                      <div class="column-expanded-left">

                        <div class="container-column">
                          <h4 class="title-column">
                            {{'ForwarderPage.ForwarderReviewsPending.TableDetail.AgreementTitle' | translate}}
                          </h4>

                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.TypeLabel' | translate}}:
                              </span>
                              {{review.productType === "program_order" ? programOrderOption : review.productType === "marketplace_order" ? marketplaceOrderOption : 'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.ExporterLabel' | translate}}:
                              </span>
                              {{review.exporter ? review.exporter.contactName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.ImporterLabel' | translate}}:
                              </span>
                              {{review.importer ? review.importer.contactName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.ConsigneeLabel' | translate}}:
                              </span>
                              {{review.delivery.consignee ? review.delivery.consignee.contactName :

                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.NotifyLabel' | translate}}:
                              </span>
                              {{review.delivery.notifier ? review.delivery.notifier.contactName :
                                'No included'}}
                            </span>
                          </div>
                        </div>
                        <div class="container-column">
                          <h4 class="title-column">
                            {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeInfoTitle' | translate}}
                          </h4>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageNameLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.name :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageContactLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStoragePhoneLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactPhone :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageEmailLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactEmail :
                                'No included'}}
                            </span>
                          </div>

                          <div class="row-info" *ngIf="translate.currentLang=='en'">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCountryLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactCountry.name :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info" *ngIf="translate.currentLang=='es'">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCountryLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactCountry.nameEs :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCityLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactCity :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageAddressLabel' | translate}}:
                              </span>
                              {{review.fridgeStorage ? review.fridgeStorage.contactAddress :
                                'No included'}}
                            </span>
                          </div>

                        </div>

                      </div>
                      <div class="column-right">

                        <!--
                          <button pButtom class="btn-ghost" (click)="goToDelivery(review)">
                            <i class="pi pi pi-table icon-network"></i>
                            {{ 'ForwarderPage.ForwarderReviewsPending.ButtonPreBL' | translate }}
                          </button>
                        -->
                        <button pButtom class="btn-ghost" (click)="goToReviewDocuments(review)">
                          <i class="pi pi pi-file icon-network"></i>
                          {{ 'QCPage.DocumentsBtn' | translate }}
                        </button>
                        <button pButtom class="btn-ghost" (click)="goToOriginReview(review)">
                          <i class="pi pi pi-file-edit icon-network"></i>
                          {{ 'QCPage.EditBtn' | translate }}
                        </button>


                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </ng-template>
          </p-dataView>
        </div>


      </div>
    </div>
  </div>

</app-user-dashboard>
